import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDashboardFast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDashboardFast"><Path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.0452 21.8396 14.053 21.5422 15H13.2372L16.0119 9.68199L14.682 8.98814L11.5454 15H2.4578C2.16035 14.053 2 13.0452 2 12Z" fill="currentColor"/><Path d="M3.06641 16.5C4.71322 19.7626 8.09488 22 11.9991 22C15.9034 22 19.285 19.7626 20.9318 16.5H3.06641Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDashboardFast;
